import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Dropdown } from 'react-bootstrap';

import { SLIDE_LIST } from '../maps';
import PDF from '../downloads/ZMG_E-Paper-Qualitaeten2024.pdf';

import { getSlugByIndex } from '../helper/slug-helper';

// SVGs
import Download from '../images/icons/download-regular.svg';

const trackDownload = (type, index) => {
  // https://www.gatsbyjs.org/docs/debugging-html-builds/#how-to-check-if-window-is-defined
  if (typeof window === 'undefined') {
    return;
  }

  if (window['ga'] === undefined) {
    return;
  }

  const url = getSlugByIndex(index);
  const action =
    type === 'pdf'
      ? `PDF wurde heruntergeladen auf Folie ${index} (/presentation/${url})`
      : `Folie ${index} wurde als PNG heruntergeladen (/presentation/${url})`;

  window['ga']('send', 'event', 'Download', action);
};

const DownloadButton = ({ index }) => {
  const fileName = SLIDE_LIST[index].download;
  const data = useStaticQuery(graphql`
    {
      allFile(filter: { extension: { eq: "png" }, sourceInstanceName: { eq: "downloads" } }) {
        edges {
          node {
            publicURL
            base
          }
        }
      }
    }
  `);

  const fileData = data.allFile.edges.find((fileData) => {
    return fileData.node.base === fileName;
  });

  return (
    <Dropdown drop="up">
      <Dropdown.Toggle variant="primary" title="Herunterladen">
        <Download width={20} />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {fileData && (
          <Dropdown.Item
            href={fileData.node.publicURL}
            download={fileData.node.base}
            onClick={() => trackDownload('png', index)}
          >
            Aktuelle Folie (PNG)
          </Dropdown.Item>
        )}
        <Dropdown.Item
          href={PDF}
          download="ZMG_E-Paper-Qualitaeten2024.pdf"
          onClick={() => trackDownload('pdf', index)}
        >
          Gesamte Präsentation (PDF)
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DownloadButton;
